<template>
    <CodiceFeanorView tool-module="pbkdf2" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
